export const serviceShowcases = [
  {
    type: 'discover',
    titleKey: 'showcase.discover.title',
    descriptionKey: 'showcase.discover.description',
    descriptionPointKeys: [
      'showcase.discover.points.0',
      'showcase.discover.points.1',
      'showcase.discover.points.2',
    ],
  },
  {
    type: 'pairing',
    titleKey: 'showcase.pairing.title',
    descriptionKey: 'showcase.pairing.description',
    descriptionPointKeys: [
      'showcase.pairing.points.0',
      'showcase.pairing.points.1',
      'showcase.pairing.points.2',
    ],
  },
  {
    type: 'editor',
    titleKey: 'showcase.editor.title',
    descriptionKey: 'showcase.editor.description',
    descriptionPointKeys: [
      'showcase.editor.points.0',
      'showcase.editor.points.1',
      'showcase.editor.points.2',
    ],
    comingSoon: true,
  },
] as const

export const steps = [
  {
    number: '01',
    titleKey: 'how.steps.0.title',
    descriptionKey: 'how.steps.0.description',
  },
  {
    number: '02',
    titleKey: 'how.steps.1.title',
    descriptionKey: 'how.steps.1.description',
  },
  {
    number: '03',
    titleKey: 'how.steps.2.title',
    descriptionKey: 'how.steps.2.description',
  },
] as const

export const perks = [
  {
    icon: '💰',
    titleKey: 'join.perks.0.title',
    descriptionKey: 'join.perks.0.description',
  },
  {
    icon: '📢',
    titleKey: 'join.perks.1.title',
    descriptionKey: 'join.perks.1.description',
  },
  {
    icon: '✏️',
    titleKey: 'join.perks.2.title',
    descriptionKey: 'join.perks.2.description',
  },
  {
    icon: '🌐',
    titleKey: 'join.perks.3.title',
    descriptionKey: 'join.perks.3.description',
  },
  {
    icon: '🎖️',
    titleKey: 'join.perks.4.title',
    descriptionKey: 'join.perks.4.description',
  },
] as const
